import React from 'react';
import './Process.css';
import logo from './assets/logo.png';
import process1 from './assets/process/process1.png';
import process2 from './assets/process/process2.png';
import process3 from './assets/process/process3.jpg';
import process4 from './assets/process/process4.jpg';

const Process = () => {
  return (
    <div className="process-container" id="process">
      <div className="process-grid">
        {/* Center Logo */}
        <div className="process-center-logo">
          <div className="logo-ring">
            <img src={logo} alt="Flora Exports" className="process-logo-img" />
          </div>
        </div>
        
        {/* Decorative Lines */}
        <div className="process-line vertical-line"></div>
        <div className="process-line horizontal-line"></div>

        {/* Quadrant 1 */}
        <div className="process-step step-tl">
          <div className="step-number-bg">01</div>
          <div className="step-content">
            <h3>01. Raw Material Selection</h3>
            <p>We source the finest bovine and lamb leathers globally, using materials like Drum Dyed, Veg Tanned, and Aniline for unique, high-quality products.</p>
          </div>
          <div className="step-image-container img-right">
            <img src={process1} alt="Raw Material Selection" />
          </div>
        </div>

        {/* Quadrant 2 */}
        <div className="process-step step-tr">
          <div className="step-image-container img-left">
            <img src={process2} alt="Design Innovation" />
          </div>
          <div className="step-number-bg">02</div>
          <div className="step-content">
            <h3>02. Design Innovation</h3>
            <p>Our Indian and in-house designers create seasonal collections, combining global trends with expert craftsmanship.</p>
          </div>
        </div>

        {/* Quadrant 3 */}
        <div className="process-step step-bl">
          <div className="step-number-bg">03</div>
          <div className="step-content">
            <h3>03. Advanced Production</h3>
            <p>Using advanced German machinery, our skilled team produces top-quality leather goods each month.</p>
          </div>
          <div className="step-image-container img-right">
            <img src={process3} alt="Advanced Production" />
          </div>
        </div>

        {/* Quadrant 4 */}
        <div className="process-step step-br">
          <div className="step-image-container img-left">
            <img src={process4} alt="Ethical Manufacturing" />
          </div>
          <div className="step-number-bg">04</div>
          <div className="step-content">
            <h3>04. Ethical Manufacturing</h3>
            <p>Our production adheres to EU regulations, ensuring social responsibility and no child labor.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Process;
